module.exports = __webpack_public_path__ + "img/plotbook.57ea0ad5.png";